
import {GET_Scrutinyapprove} from '../constants/ActionTypes'

const INIT_STATE = {
    scrutinyapprove: null
   
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_Scrutinyapprove:
                return {
                    scrutinyapprove: action.body,
                    
                  
                }
        default:
            return state;
    }
}